import React from 'react';
import PropTypes from 'prop-types';
import Grid from '../../Grid';
import Card from '../../Card';
import CardBody from '../../CardBody';
import Typography from '../../Typography';

const HitComponent = ({ hit }) => {
  const { title, overview, poster, release_year: releaseYear } = hit;

  return (
    <Grid column xs={12}>
      <Card className="h-100 flex-row">
        <div
          style={{ position: 'relative', paddingTop: 225, overflow: 'hidden', width: 150 }}
          className="flex-shrink-0"
        >
          <img
            src={poster}
            alt={title}
            loading="lazy"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              objectFit: 'cover',
              borderRadius: 4,
            }}
          />
        </div>
        <CardBody className="d-flex flex-column">
          <Typography variant="subtitle-1" weight="bold">
            {title}{' '}
            <Typography variant="body-medium" weight="medium" component="span">
              ({releaseYear})
            </Typography>
          </Typography>
          <Typography variant="body-small">{overview}</Typography>
        </CardBody>
      </Card>
    </Grid>
  );
};

HitComponent.propTypes = {
  hit: PropTypes.object,
};

HitComponent.defaultProps = {
  hit: {},
};

export default HitComponent;
